import * as React from 'react';

import {LoadingPage} from 'shells/loading-page/loading-page';

import {useGetWhatsAppIntegration} from '../graphql/hooks/use-get-whatsapp-integration';
import {useToggleWhatsAppIsEnabled} from '../graphql/hooks/use-toggle-whatsapp-is-enabled';
import {OnboardingModalWrapper} from '../onboarding/onboarding-modal-wrapper';

import {SettingsIntegrationComplete} from './settings-integration-complete';
import {SettingsNoIntegration} from './settings-no-integration';

export function Settings() {
    const [errorMessage, setErrorMessage] = React.useState<string | null>(null);
    const [isOnboardingModalOpen, setIsOnboardingModalOpen] = React.useState<boolean>(false);

    const {
        whatsAppIntegration,
        isLoading: isLoadingWhatsAppIntegration,
        refetch: refetchWhatsAppIntegration,
        startPolling,
        stopPolling,
        errorMessage: error,
    } = useGetWhatsAppIntegration();
    const {toggleWhatsAppIsEnabled} = useToggleWhatsAppIsEnabled();

    const isConnected = whatsAppIntegration && whatsAppIntegration.hasAuthToken;

    React.useEffect(() => {
        if (error) {
            setErrorMessage(error);
        }
    }, [error]);

    // This is mainly done for two reasons:
    // 1. in the rcfx embed, they are redirected to a new tab for auth
    // so we gotta make sure we're polling the current tab to update the integration status
    // 2. deauthorize can be triggered via a webhook, so we need to make sure we're polling
    // to update the integration status on this page when that happens
    React.useEffect(() => {
        startPolling(5000);

        return () => stopPolling();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onToggleClick = () => {
        toggleWhatsAppIsEnabled(whatsAppIntegration.isEnabled);
    };

    if (isLoadingWhatsAppIntegration && !whatsAppIntegration) {
        return <LoadingPage />;
    }

    return (
        <div className='px-16 py-24 full-width overflow-auto'>
            {isConnected ? (
                <SettingsIntegrationComplete whatsAppIntegration={whatsAppIntegration} />
            ) : (
                <SettingsNoIntegration
                    errorMessage={errorMessage || undefined}
                    setIsOnboardingModalOpen={setIsOnboardingModalOpen}
                />
            )}
            {isOnboardingModalOpen && (
                <OnboardingModalWrapper
                    isConnected={isConnected}
                    setIsOnboardingModalOpen={setIsOnboardingModalOpen}
                    refetchWhatsAppIntegration={refetchWhatsAppIntegration}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    whatsappPhoneNumber={
                        (whatsAppIntegration && whatsAppIntegration.userPhoneNumber) || ''
                    }
                    isEnabled={whatsAppIntegration && whatsAppIntegration.isEnabled}
                    enableIntegration={onToggleClick}
                    disableIntegration={onToggleClick}
                />
            )}
        </div>
    );
}
